<template>
  <div class="comment-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>评论内容</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入评论内容" v-model="table.search.content"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>帖子内容</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入帖子内容" v-model="table.search.invitation"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>发表用户</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入发表用户" v-model="table.search.user"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>所属版块</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.section" class="app-block" placeholder="请选择所属版块">
              <a-select-option :value="value.id" v-for="value in sectionOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="status" slot-scope="text, data">
        <a-tag color="blue" v-if="!data.is_hide">显示</a-tag>
        <a-tag v-else>隐藏</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanComment(data)">查看</a-button>
          <a-button type="link" @click="enableComment(data)" v-if="data.is_hide">显示</a-button>
          <a-button type="link" @click="disableComment(data)" v-else>隐藏</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <invitation-details :id="drawer.id" :community-id="communityId"></invitation-details>
    </a-drawer>
  </div>
</template>

<script>
  import CommentService from '@/io/comment.js';
  import SectionService from '@/io/section.js';
  import InvitationDetails from '@/views/community/InvitationDetails.vue';

  export default {
    name: 'CommentManage',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            content: null,
            invitation: null,
            user: null,
            section: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '评论内容',
              dataIndex: 'content'
            },
            {
              title: '帖子内容',
              dataIndex: 'posts_content'
            },
            {
              title: '所属版块',
              dataIndex: 'posts_category.name'
            },
            {
              title: '评论用户',
              dataIndex: 'user_nickname'
            },
            {
              title: '评论时间',
              dataIndex: 'created_at'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'status' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        sectionOptions: [],
        drawer: {
          id: null,
          title: '帖子详情',
          show: false,
        }
      }
    },
    components: {
      InvitationDetails,
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.initSection().then(() => {
              this.searchTable();
            });
          }
        },
        immediate: true
      }
    },
    methods: {
      scanComment(data) {
        this.drawer.id = data.posts_id;
        this.drawer.show = true;
      },
      enableComment(data) {
        CommentService.enable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      disableComment(data) {
        CommentService.disable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          content: null,
          invitation: null,
          user: null,
          section: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initSection() {
        return SectionService.list(this.communityId).then(res => {
          this.sectionOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        CommentService.listPage(
          this.communityId,
          this.table.search.content,
          this.table.search.invitation,
          this.table.search.user,
          this.table.search.section,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>